import React, { useState, useContext } from 'react'

import { SignupContext } from 'contexts/SignupContext'

import { history } from 'routers/AppRouter'

import Register from '../Register'
import { stepsList } from './Steps'

import Row from 'components/Row'
import { Column, TextInput, CheckBox } from 'components'
import { Typography, Button, Select } from '@telavita-core/react-design-kit'

import { REGISTER_PHONE_CHECK } from 'settings/_routesSettings'
import { PlanGroupCategoryEnum } from 'settings/_planGroupSettings'
import { GENDER } from 'settings/_personSettings'

import { PASSWORD_NOT_EQUAL } from 'utils/ValidationErrorList'

const InfoPersonal = () => {

  const {
    firstName,
    lastName,
    cpf,
    dateBirth,
    gender,
    email,
    password,
    planGroup,
    firstNameMsg,
    lastNameMsg,
    cpfMsg,
    dateBirthMsg,
    emailMsg,
    passwordMsg,
    setFirstName,
    setLastName,
    setCpf,
    setDateBirth,
    setGender,
    setEmail,
    setPassword,
    isFirstNameValid,
    isLastNameValid,
    isCpfValid,
    isDateBirthValid,
    isGenderValid,
    isEmailValid,
    isPasswordValid
  } = useContext(SignupContext)

  const [passwordsMatch, setPasswordsMatch] = useState(true)
  const [retypePassword, setRetypePassword] = useState('')
  const [readTerms, setReadTerms] = useState(false)

  const { CORPORATE_LIMITED, CORPORATE_UNLIMITED, CAPITATION } = PlanGroupCategoryEnum

  const showCpfInput = ([CORPORATE_LIMITED, CORPORATE_UNLIMITED, CAPITATION]).includes(planGroup.category)

  function onPasswordChange(e) {
    let passwordValue = e.target.value

    setPassword(passwordValue)

    if (retypePassword !== '') {
      setPasswordsMatch(false)
      setRetypePassword('')
    }
  }

  function onPasswordConfirm(e) {
    let inputValue = e.target.value
    if (password === inputValue) {
      setPasswordsMatch(true)
      setRetypePassword(inputValue)
    } else {
      setPasswordsMatch(false)
      setRetypePassword(inputValue)
    }
  }

  async function onNextStep() {
    if (checkNextIsReady()) {
      history.push(REGISTER_PHONE_CHECK)
    }
  }

  function handleToggle(selected) {
    setReadTerms(selected)
  }

  function onPrevStep() {
    setFirstName(null)
    setLastName(null)
    setCpf(null)
    setDateBirth(null)
    setEmail(null)
    setPassword(null)
    history.goBack()
  }

  function checkNextIsReady() {
    return (
      isFirstNameValid &&
      isLastNameValid &&
      isCpfValid &&
      isDateBirthValid &&
      isGenderValid &&
      isEmailValid &&
      isPasswordValid &&
      passwordsMatch &&
      readTerms
    )
  }

  function handleSelectGender(selectedGender) {
    setGender(prevState => ({
      ...prevState,
      id: selectedGender.id,
      label: selectedGender.label,
      code: GENDER.find(item => item.id === selectedGender.id).code
    }))
  }

  const genderOptions = GENDER
    .map(item => ({
      id: item.id,
      label: item.name,
      code: item.code
    }))

  return (
    <Register
      showStepper={true}
      showLoginInfo={false}
      currentStep={stepsList.INFO_PERSONAL}
    >
      <Row justify="center">
        <Typography
          center
          variant="content2"
        >
          Preencha seus dados abaixo:
        </Typography>
      </Row>

      <Row justify="center" margin='25px 0 0'>
        <Column>

          <TextInput
            autofocus
            hasError={firstNameMsg}
            messageError={firstNameMsg}
            name="firstName"
            onInputChange={(e) => setFirstName(e.target.value)}
            placeholder="Nome"
            required
            type="text"
            value={firstName}
            data-cy='signup-input-firstName'
          />

          <TextInput
            hasError={lastNameMsg}
            messageError={lastNameMsg}
            name="lastName"
            onInputChange={(e) => setLastName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onNextStep()
                e.preventDefault()
              }
            }}
            placeholder="Sobrenome"
            required
            type="text"
            value={lastName}
            data-cy='signup-input-lastName'
          />

          {
            !showCpfInput && (
              <TextInput
                hasError={cpfMsg}
                messageError={cpfMsg}
                name="cpf"
                onInputChange={(e) => setCpf(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    onNextStep()
                    e.preventDefault()
                  }
                }}
                placeholder="CPF"
                required
                type="text"
                value={cpf}
                mask='111.111.111-**'
                data-cy='signup-input-cpf'
              />
            )
          }

          <TextInput
            placeholder="Data de nascimento"
            name="dateBirth"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onNextStep()
                e.preventDefault()
              }
            }}
            hasError={dateBirthMsg}
            messageError={dateBirthMsg}
            mask="11/11/1111"
            onInputChange={(e) => setDateBirth(e.target.value)}
            value={dateBirth}
            data-cy='signup-input-birthDate'
            required
          />

          <Select
            placeholder='Gênero'
            selected={gender}
            customClassName="Register__Select__Gender"
            onSelect={(genderOption) => handleSelectGender(genderOption)}
            options={genderOptions}
            dataCy='signup-select-gender'
          />
               
          <TextInput
            hasError={emailMsg}
            messageError={emailMsg}
            name="email"
            onInputChange={(e) => setEmail(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onNextStep()
                e.preventDefault()
              }
            }}
            placeholder="E-mail"
            required
            type="text"
            value={email}
            data-cy='signup-input-email'
          />

          <TextInput
            hasError={passwordMsg}
            isPassword
            messageError={passwordMsg}
            name="password"
            onInputChange={onPasswordChange}
            placeholder="Senha"
            required
            value={password}
            data-cy='signup-input-password'
          />

          <TextInput
            hasError={!passwordsMatch}
            name="retypePassword"
            messageError={passwordsMatch ? '' : PASSWORD_NOT_EQUAL}
            onInputChange={onPasswordConfirm}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onNextStep()
                e.preventDefault()
              }
            }}
            placeholder="Confirmação de senha"
            required
            type='password'
            value={retypePassword}
            data-cy='signup-input-retypePassword'
          />
        </Column>
      </Row>

      <Row justify="center" margin='10px 0 0'>
        <Row wrap>
          <CheckBox
            checkBoxId="confirm-read-terms"
            onClickCheckBox={handleToggle}
            data-cy='signup-checkbox-terms'
            isSelected={readTerms}
          />
          <Typography variant='content2'>
            Li e aceito os
            <a 
              href={process.env.REACT_APP_TELAVITA_TERMS_OF_USE_URL} 
              target='_blank' 
              className="Register__Link"
            >
              termos e condições
            </a> 
            e a
            <a 
              href={process.env.REACT_APP_TELAVITA_PRIVACY_POLICY_URL}
              target='_blank'
              className="Register__Link"
            >
              política de privacidade
            </a>
          </Typography>
        </Row>
      </Row>

      <Row align='space-between' direction='row' margin='20px 0 0' wrap='nowrap'>
        <Button
          variant='outlined'
          onClick={onPrevStep}
          uppercase={false}
          inlineStyles={{
            width: '100%',
            marginRight: '5px'
          }}
        >
          Voltar
        </Button>
        <Button
          variant='contained'
          disabled={!checkNextIsReady()}
          onClick={onNextStep}
          uppercase={false}
          inlineStyles={{
            width: '100%',
            marginLeft: '5px'
          }}
          data-cy='signup-next-step'
        >
          Próximo
        </Button>
      </Row>
    </Register>
  )
}

export default InfoPersonal
